module.exports = __webpack_public_path__ + "static/media/ednaclyde00.c63464cb.png";